
export const RENT_GET_REQUEST = "RENT_GET_REQUEST";
export const RENT_GET_SUCCESS = "RENT_GET_SUCCESS";
export const RENT_GET_FAILURE = "RENT_GET_FAILURE";